let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bCZbu")).then(() => parcelRequire('2cNOn'));